import React from "react";
import { CgWebsite } from "react-icons/cg";
import SectionHead from "../common/SectionHead";
import MediaCard from "../common/MediaCard";
import { ventures } from "../../data/content";

/* NoStag has no live page yet (pageLink "#"), so it renders without a link. */
function ventureLinks(venture) {
  if (!venture.url) return [];
  return [{ href: venture.url, label: "Visit page", Icon: CgWebsite }];
}

function Ventures({ as = "h2", withHead = true }) {
  return (
    <section className="section" id="ventures">
      <div className="container">
        {withHead && (
          <SectionHead
            as={as}
            eyebrow="Ventures"
            title="My Ventures"
            lede="Products and businesses I'm building."
          />
        )}

        <div className="card-grid">
          {ventures.map((venture) => (
            <MediaCard
              key={venture.title}
              image={venture.image}
              title={venture.title}
              description={venture.description}
              links={ventureLinks(venture)}
              logo
            />
          ))}
        </div>
      </div>
    </section>
  );
}

export { ventureLinks };
export default Ventures;
